import { Component, OnInit } from '@angular/core';
import { KilnService } from '../services/kiln.service';
import { AccountService } from '../services/account.service';

@Component({
  selector: 'app-admin-stats',
  templateUrl: './admin-stats.component.html',
  styleUrls: ['./admin-stats.component.css'],
})
export class AdminStatsComponent implements OnInit {
  loading = true;

  public kilns = {
    total: '',
    free: { total: '', firing_count: '' },
    premium: { total: 0, firing_count: '' },
    online: '',
    offline: '',
    firing: '',
    fw_versions: [],
    fw: {},
  };

  public accounts = {
    premium: '',
    free: '',
    loggedInUsers: '',
    totalUsers: '',
    premium_users: '',
  };

  constructor(
    public kilnService: KilnService,
    public accountService: AccountService,
  ) {}

  ngOnInit() {
    void Promise.all([
      this.loadKilnStatistics(),
      this.loadAccountStatistics(),
    ]).finally(() => {
      this.loading = false;
    });
  }

  private async loadKilnStatistics(): Promise<void> {
    try {
      const statistics = await this.accountService.getFiringStatistics();
      if (!statistics) {
        return;
      }

      this.kilns.total = statistics.total;
      this.kilns.free = statistics.free;
      this.kilns.premium = statistics.premium;
      this.kilns.online = statistics.tenMinutes;
      this.kilns.offline = statistics.threeMonthAgo;
      this.kilns.firing = statistics.firing;
      this.kilns.fw_versions = Object.keys(statistics.fw)
        .reduce((all, current) => {
          if (statistics.fw[current]) {
            all.push({ key: current, value: statistics.fw[current] });
          }
          return all;
        }, [])
        .filter((version) => version.value > 10)
        .sort((a, b) => (a.value >= b.value ? -1 : 1));
      this.kilns.fw = statistics.fw;
    } catch (e) {
      console.log(e);
    }
  }

  private async loadAccountStatistics(): Promise<void> {
    try {
      const [premiumStats, userCountResponse, userEvents] = await Promise.all([
        this.accountService.premiumUserStatistics(),
        this.accountService.userCount(),
        this.accountService.userEvents(),
      ]);

      this.accounts.premium = premiumStats.premium.total_accounts;
      this.accounts.premium_users = premiumStats.premium.total_users || 0;
      this.accounts.totalUsers = userCountResponse.userCount || 0;
      this.accounts.loggedInUsers = userEvents.signInSuccessCount;
      this.updateFreeUserCount();
    } catch (e) {
      console.log(e);
    }
  }

  private updateFreeUserCount(): void {
    const totalUsers = Number(this.accounts.totalUsers);
    const premiumUsers = Number(this.accounts.premium_users);
    if (!Number.isNaN(totalUsers) && !Number.isNaN(premiumUsers)) {
      this.accounts.free = String(totalUsers - premiumUsers);
    }
  }
}
